import * as React from "react";
import Title from "../../app/components/Title";
import { Box, Grid, ListItemButton, ListItemText } from "@mui/material";
import {
  setDbParams,
  setRecentlySelecteDBS,
} from "../../app/store/entrezDbSlice";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import { styled } from "@mui/system";
import { convertFirstCharToCaps } from "../../app/util/util";
// example showing styling a component using styled utility
const MyComponent = styled("div")({
  display: "flex",
  flexFlow: "column wrap",
  gap: "0 30px",
  backgroundColor: "pink",
  height: 300, // set the height limit to your liking
  overflow: "auto",
});
export default function RecentDBs() {
  const { recentSelectedDBs } = useAppSelector((state) => state.entrezDb);

  const dispatch = useAppDispatch();

  // const entrezdbs = useAppSelector(entrezDbSelectors.selectAll);

  const handleDatabaseSelection = (selectedDB: string) => {
    console.log("Selected DB is: " + selectedDB);

    //reset the state on selection of database..
    dispatch(setDbParams({ db: selectedDB }));
    //dispatch(resetSearchResults());
    //dispatch(resetMetaData());
    dispatch(setRecentlySelecteDBS({ db: selectedDB }));
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="left">
      <Title>Recently Used DBs</Title>

      {/* <MyComponent >
        {recentSelectedDBs &&
          recentSelectedDBs.map((dbname) => {
            return (
              <ListItem key={dbname} sx={{width: "auto"}}>
                <ListItemIcon>
                  <Checkbox edge="start" disableRipple />
                </ListItemIcon>
                <ListItemText primary={dbname} />
              </ListItem>
            );
          })}
      </MyComponent> */}

      <Grid container rowSpacing={1} columnSpacing={{ xs: 1 }}>
        {recentSelectedDBs &&
          recentSelectedDBs.map((dbname) => (
            <Grid key={dbname} item xs={6}>
              <ListItemButton
                sx={{
                  borderRadius:1,
                  margin: 1,
                  minWidth: 100,
                  textAlign: "left",
                  backgroundColor: "secondary.light",
                  "&:hover": {
                    backgroundColor: "secondary.main",
                    color: "white",
                  },
                }}
                key={dbname}
                onClick={() => handleDatabaseSelection(dbname)}
              >
                <ListItemText primaryTypographyProps={{fontSize: '.8em'}}  primary={convertFirstCharToCaps(dbname)} />
              </ListItemButton>
            </Grid>
          ))}
      </Grid>
    </Box>
    // <Box display="flex" flexDirection="column" alignItems="center">
    //   <Title>Recently Used DBs</Title>
    //   {recentSelectedDBs && (
    //     <Box display="flex"  flexDirection="column" overflow= "auto" alignItems="center">
    //       <Stack spacing={1} alignItems="center">
    //         <Stack direction="row" spacing={1}>
    //           {recentSelectedDBs.map((dbname) => (
    //             <Chip label={dbname} color="primary" />
    //           ))}
    //         </Stack>
    //         <Stack direction="row" spacing={1}>
    //           <Chip label="primary" color="primary" variant="outlined" />
    //           <Chip label="success" color="success" variant="outlined" />
    //         </Stack>
    //       </Stack>
    //     </Box>
    //   )}
    // </Box>
  );
}
